import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MuiDrawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { SidebarItems } from './SidebarItems';
import { Drawer, drawerWidth } from './Drawer';
import { Toolbar, Typography } from '@mui/material';

type Props = {
  open: boolean;
  isMobile: boolean;
  toggleSidebar: () => void;
}

export const Sidebar: React.FC<Props> = ({ open, isMobile, toggleSidebar }) => {
  const location = useLocation();

  // On mobile the drawer overlays the page; close it after navigating.
  useEffect(() => {
    if (isMobile && open) toggleSidebar();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const content = (
    <>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: [1],
        }}
      >
        <Typography variant="h4">Admesh</Typography>
        <IconButton onClick={toggleSidebar} aria-label="Lukk meny">
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <SidebarItems />
    </>
  );

  if (isMobile) {
    return (
      <MuiDrawer
        variant="temporary"
        open={open}
        onClose={toggleSidebar}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' } }}
      >
        {content}
      </MuiDrawer>
    );
  }

  return (
    <Drawer variant="permanent" open={open}>
      {content}
    </Drawer>
  );
}
